<template>
  <div class="electron-discovery-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex><strong>公式：</strong>Thomson's e/m ratio</div>
    </div>

    <div class="main-layout vertical">
      <!-- 仿真区：阴极射线管 -->
      <div class="canvas-item simulation">
         <svg width="100%" height="220" viewBox="0 0 400 220">
            <!-- 玻璃管 -->
            <rect x="50" y="70" width="300" height="80" rx="40" fill="none" stroke="rgba(0,210,255,0.2)" stroke-width="2" />
            
            <!-- 阴极 & 阳极 -->
            <line x1="60" y1="110" x2="80" y2="110" stroke="#ff4757" stroke-width="4" />
            <rect x="120" y="90" width="10" height="40" fill="#2ed573" />
            
            <!-- 电子束 -->
            <line x1="80" y1="110" :x2="350" :y2="beamY" stroke="#00d2ff" stroke-width="2" opacity="0.6">
               <animate attributeName="stroke-dasharray" from="5,5" to="0,10" dur="0.5s" repeatCount="indefinite" />
            </line>

            <!-- 电偏转板 -->
            <rect x="180" y="75" width="40" height="4" fill="#ffd700" />
            <rect x="180" y="141" width="40" height="4" fill="#ffd700" />
         </svg>

         <div class="hud-top">
            <div class="stat">
               <label>偏转电场强度 E</label>
               <span class="val">{{ electricField }} V/m</span>
            </div>
         </div>
      </div>

      <!-- 参数控制 -->
      <div class="bottom-controls">
         <div class="control-card glass">
            <div class="row">
               <div class="col-full">
                  <label>调节偏转电压 (改变电子径迹)</label>
                  <el-slider v-model="electricField" :min="-100" :max="100" size="mini"></el-slider>
               </div>
            </div>
         </div>

         <div class="discovery-note" v-latex>
            <p><strong>历史意义：</strong>1897年，汤姆孙通过研究<strong>阴极射线</strong>在磁场和电场中的偏转，证明了射线的本质是带负电的粒子流，并命名为<strong>电子</strong>。这打破了原子不可分的传统观念。</p>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ElectronDiscoveryViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      electricField: 0
    }
  },
  computed: {
    beamY() {
       return 110 + this.electricField * 0.4;
    }
  }
}
</script>

<style scoped lang="scss">
.electron-discovery-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.viz-header { display: flex; justify-content: space-between; align-items: center; .title { font-size: 1rem; color: #fff; } .formula-chip { color: #00d2ff; background: rgba(0,210,255,0.1); padding: 4px 12px; border-radius: 8px; font-weight: bold; } }
.canvas-item { 
   background: #000; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05);
   .hud-top { position: absolute; top: 15px; right: 15px; .val { color: #ffd700; font-family: monospace; } }
}
.bottom-controls { flex: 0.5; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; .row { .col-full { label { font-size: 0.7rem; color: #888; display: block; margin-bottom: 5px; } } } }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
